import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-col-12 p-grid p-mr-0 p-ml-0 p-pb-0 p-pt-3"
}
const _hoisted_2 = { class: "p-col-8 p-pl-0" }
const _hoisted_3 = { class: "headline p-component p-m-0" }
const _hoisted_4 = { class: "p-col-4 p-as-center p-grid p-jc-end" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "p-text-bold" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid p-mt-2" }
const _hoisted_9 = { class: "p-field p-col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showHeadline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.System.System')) + " " + _toDisplayString(_ctx.$t('Squeeze.System.Info')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              class: "p-button p-button-rounded p-button-text",
              icon: "mdi mdi-close",
              onClick: _ctx.clickSettingDialog
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.showHeadline ? 'p-col-12 p-m-0' : '')
    }, [
      (Object.keys(_ctx.systemInformation).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.System.Info') })), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.systemInformation), (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "p-p-2"
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(info[0]) + ": ", 1),
                    _createElementVNode("td", null, _toDisplayString(info[1]), 1),
                    _createElementVNode("td", null, [
                      _withDirectives(_createVNode(_component_Button, {
                        icon: "mdi mdi-content-copy",
                        type: "button",
                        class: "p-button p-button-lg p-button-rounded p-button-text",
                        style: {"height":"1.5rem"},
                        onClick: ($event: any) => (_ctx.onClickCopyToClipboard(info[0], info[1]))
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('Squeeze.General.CopyToClipboard'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "p-offset-8" }, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('Squeeze.General.CopyAll'),
                  type: "button",
                  icon: "mdi mdi-content-save-all-outline",
                  class: "p-button",
                  onClick: _ctx.onCopyAllClick
                }, null, 8, ["label", "onClick"])
              ])
            ])
          ]))
    ], 2)
  ], 64))
}